import React from "react";

const AddIcon = () => (
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.5 11V7C13.5 6.73478 13.3946 6.48043 13.2071 6.29289C13.0196 6.10536 12.7652 6 12.5 6C12.2348 6 11.9804 6.10536 11.7929 6.29289C11.6054 6.48043 11.5 6.73478 11.5 7V11H7.5C7.23478 11 6.98043 11.1054 6.79289 11.2929C6.60536 11.4804 6.5 11.7348 6.5 12C6.5 12.2652 6.60536 12.5196 6.79289 12.7071C6.98043 12.8946 7.23478 13 7.5 13H11.5V17C11.5 17.2652 11.6054 17.5196 11.7929 17.7071C11.9804 17.8946 12.2348 18 12.5 18C12.7652 18 13.0196 17.8946 13.2071 17.7071C13.3946 17.5196 13.5 17.2652 13.5 17V13H17.5C17.7652 13 18.0196 12.8946 18.2071 12.7071C18.3946 12.5196 18.5 12.2652 18.5 12C18.5 11.7348 18.3946 11.4804 18.2071 11.2929C18.0196 11.1054 17.7652 11 17.5 11H13.5Z"
      fill="currentColor"
      fillOpacity="0.5"
    />
  </svg>
);

export default AddIcon;
